import {SpinnerService} from "../../modules/SpinnerModule";
import {DataHubService} from "../../modules/DataHubModule";
import {XheoDebugLogDto} from "../../model/XheoDebugLogDto";

export class XheoDebugLogController {
    private logs: XheoDebugLogDto[] = [];


    constructor(private $dataHub: DataHubService,
                private $spinner: SpinnerService,
                private $stateParams: any) {
        this.$dataHub.bindAllXheoDebugLog(() => this.logs);
        $dataHub.onConnected(this.refresh)
    }

    refresh = () => {
        let license = this.$stateParams.licenseNumber || '';
        console.debug('license', license);
        this.$spinner.show('Loading');
        this.$dataHub.xheoDebugLogSub(license)
            .catch(this.$dataHub.defaultErrorHandler)
            .finally(() => this.$spinner.hide());
    }
}
